export default __webpack_public_path__ + "static/media/Joel's_Resume.601824a6.pdf";